import React from "react";
import {
  Bar,
  IconsWrapper,
  Logo,
  LogoWrapper,
  MessageWrapper,
} from "./Appbar.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { DownloadOutlined, MessageOutlined, SearchOutlined } from "@assets";
import { useTranslation } from "react-i18next";

const Appbar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToDownload = () => {
    navigate(`/${PUBLIC_ROUTE.APP_DOWNLOAD}`);
  };

  const goToMessages = () => {
    navigate(`/${PUBLIC_ROUTE.MESSAGE}`);
  };

  const goToSearch = () => {
    navigate(`/${PUBLIC_ROUTE.SEARCH}`);
  };

  return (
    <Bar>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <IconsWrapper>
        <MessageWrapper onClick={goToMessages}>
          <MessageOutlined />
          {t("message.chat")}
        </MessageWrapper>
        <SearchOutlined onClick={goToSearch} />
        <DownloadOutlined onClick={goToDownload} />
      </IconsWrapper>
    </Bar>
  );
};

export default Appbar;
